var Messages = function () {
    var self = this;

    this.list = ko.observableArray();

    this.focused = ko.observable(false).extend({
        notify: 'always'
    });

    this.isEmpty = function () {
        return self.list().length == 0
    };

    this.addItem = function (item, action, action_link, actionCallback) {
        if (!item) return;

        self.list.push({
            text: item,
            action: action || null,
            action_link: action_link || 'Yes',
            actionCallback: function () {
                if (action && actionCallback) actionCallback();

                self.list.remove(this);
            }
        });
    };
    this.addItems = function (list, options) {
        if (!list || !Array.isArray(list)) return;

        if (options && options.clear) {
            self.removeAllItems();
        }

        list.forEach(function (item) {
            self.addItem(item);
        });
    };
    this.removeItem = function () {
        self.list.remove(this)
    };
    this.removeAllItems = function () {
        self.list([]);
    };
    this.setFocus = function () {
        self.focused(true);
    };
    this.removeFocus = function () {
        self.focused(false);
    }
};

module.exports = new Messages();


//////////////////
// WEBPACK FOOTER
// ../textbookx/service/bulk_po/scripts/components/messages.js
// module id = 2
// module chunks = 0